import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-job_detail_geo",
  "use": "icon-job_detail_geo-usage",
  "viewBox": "0 0 24 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 28\" id=\"icon-job_detail_geo\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-3-1h30v30H-3z\" /><path d=\"m12 24.292 6.188-6.188a8.75 8.75 0 1 0-12.375 0L12 24.292Zm0 3.535-7.955-7.955c-4.393-4.394-4.393-11.517 0-15.91 4.393-4.394 11.517-4.394 15.91 0 4.393 4.393 4.393 11.516 0 15.91L12 27.827Zm0-13.41a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 2.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z\" fill=\"gray\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol